import React, { useEffect } from "react"
import { observer } from "mobx-react-lite"
import { Table, ScrollArea, rem } from "@mantine/core"
import { InstructorStore } from "../../app/store"
import { type Instructor } from "../../shared/types/instructor"
import { ResultWrapper } from "../../entities/resultWrapper"
import { DragDropContext, Droppable } from "react-beautiful-dnd"

// ----------------------------------------------------------------------

type Props = {
  rowComponent: React.JSXElementConstructor<Instructor>
}

export const InstructorTable = observer(function InstructorTable({ rowComponent }: Props) {
  const { instructors, reorder, isLoading, getAll, error } = InstructorStore
  const Row = rowComponent

  useEffect(() => {
    void getAll({ publishedOnly: false })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  // console.log(toJS(instructors))
  return (
    <ResultWrapper
      isLoading={isLoading}
      isEmpty={!instructors.length}
      error={error}
    >
      <ScrollArea sx={{ flex: "auto" }}>
        <DragDropContext
          onDragEnd={({ destination, source }) => {
            if (destination?.index !== undefined && destination.index !== source.index) {
              reorder(source.index, destination.index)
            }
          }
          }
        >
          <Table highlightOnHover sx={{ minWidth: 800 }} verticalSpacing="sm">
            <thead>
            <tr>
              <th style={{ width: rem(40) }}/>
              <th>Преподаватель</th>
              <th style={{ textAlign: "center" }}>Опубликован</th>
              <th style={{ textAlign: "right" }}>Действия</th>
            </tr>
            </thead>
            <Droppable droppableId="dnd-instructor-list" direction="vertical">
              {({ droppableProps, placeholder, innerRef }) => (
                <tbody {...droppableProps} ref={innerRef}>
                {instructors.map((instructor) => (
                  <Row key={instructor._id} {...instructor} />
                ))}
                {placeholder}
                </tbody>
              )}
            </Droppable>
          </Table>
        </DragDropContext>
      </ScrollArea>
    </ResultWrapper>
  )
})
